import { z } from 'zod';
import { OrganizationSchema } from '../../../../entities/organization/organization.schema';
import { BaseErrorSchema } from '../../../../shared/error.schema';
/**
 * Update Tenant Organization Request Schema
 * PATCH /api/v2/tenants/:tenantId/organization
 *
 * Superadmin-controlled: enableAI toggle only. Model selection is global via PlatformSettings.
 */ export const UpdateTenantOrganizationRequestSchema = z.object({
    settings: z.object({
        enableAI: z.boolean()
    })
});
/**
 * Update Tenant Organization Response Schema
 */ export const UpdateTenantOrganizationResponseSchema = z.object({
    data: OrganizationSchema
});
/**
 * Update Tenant Organization Error Schema
 */ export const UpdateTenantOrganizationErrorSchema = BaseErrorSchema;

//# sourceMappingURL=update-tenant-organization.schema.js.map